/** Claves de users_modules usadas por el menú y rutas (orden no importa). */
export const RBAC_APP_MODULE_KEYS = [
  'dashboards',
  'xtam_vms',
  'mapa',
  'alarmas',
  'administracion',
  'seguridad'
] as const;

/**
 * Roles/usuarios/auditoría bajo /security/* y API RBAC: requiere módulo `seguridad` en la matriz.
 * Compatibilidad: nombre legado `Administrador` (seeds antiguos).
 */
export function canAccessSecurityAdmin(
  user: { role?: string; allowedModules?: string[] } | null | undefined
): boolean {
  if (!user) return false;
  if (user.role === 'Administrador') return true;
  return Boolean(user.allowedModules?.includes('seguridad'));
}

/**
 * Ver todos los módulos en el menú sin filtrar por lista (equivalente al antiguo "es Administrador").
 */
export function hasFullRbacMenuBypass(
  user: { role?: string; allowedModules?: string[] } | null | undefined
): boolean {
  if (!user) return false;
  if (user.role === 'Administrador') return true;
  const m = user.allowedModules;
  if (!m?.length) return false;
  return RBAC_APP_MODULE_KEYS.every((k) => m.includes(k));
}
